
'use strict'

export function getHasValueValidateFn (type, subType, hasValueFn) {
  if (!hasValueFn) {
    hasValueFn = getDefaultHasValueFn(type, subType)
  }

  return function (val) {
    const requiredFn = this.requiredFn
    if (requiredFn && requiredFn.call(this)) {
      return hasValueFn(val)
    }
    return true
  }
}

function getDefaultHasValueFn (type, subType) {
  if (type === 'address') {
    return val => !!val && !!val.value && val.value !== ''
  } else if (subType === 'brigades') {
    return val => !!val && val.length !== 0 && !!val.find(b => b.assigned) && !val.find(b => b._notValid)
  } else if (type === 'datetime' || type === 'duration') {
    return val => !!val
  } else if (type === 'boolean') {
    return val => val === false || val === true
  } else if (type === 'brigade') {
    return val => !!val && !!val.id
  } else if (type === 'number') {
    return val => !!val && val > 0
  } else if (type === 'table') {
    return val => !!val && val.filter(v => !v.removed).length > 0
  } else {
    return val => !!val && val.length !== 0
  }
}
